import { Component, Input, OnInit } from '@angular/core';
import { SharedDataService } from '../../../../@core/service/shared-data.service';

@Component({
  selector: 'pfspo-availability-component',
  templateUrl: './pfspo-availability-page.component.html',
  styleUrls: ['./pfspo-availability-page.component.scss']
})
export class PfspoAvailabilityPageComponent implements OnInit {

  @Input() compilation = null;
  @Input() lineItem = null;

  disabled = true;

  constructor(private data: SharedDataService) { }

  ngOnInit(): void {
    this.data.loadBusinesses();
  }

}
